import { isChangeHostname } from './isChangeHostname';

export function isChangeUrl(url: string): boolean {
	// If `to` is a relative URL, then assume it's an internal link
	const fullUrl = new URL(url, 'https://www.change.org/');

	return isChangeHostname(fullUrl.hostname);
}
